module.exports = __webpack_public_path__ + "img/not-purchased.5c92c07b.webp";